import React from "react";

export const Textarea = (props) => {
  const { field, fieldId } = props;
  const { label, placeholder, isRequired, cssClass, id, size, labelPlacement, layoutGridColumnSpan, description } = field;

  const columnClass = `col-span-${layoutGridColumnSpan}`;
  // Gravity Form field ID ~ name.
  const gfName = `input_${id}`;
  return (
    <div
      className={`${cssClass ? ` ${cssClass}` : ""}${isRequired ? " required" : ""} ${size} ${labelPlacement} ${columnClass}`}
    >
      <label htmlFor={fieldId}>{label}</label>
      <textarea
        name={gfName}
        id={fieldId}
        placeholder={placeholder}
        required={!!isRequired}
        resize="none"
      />
      {description && (<p className="description">{description}</p>)}
    </div>
  );
};
